import { makeVar } from "@apollo/client";

export const unreadMessagesCountVar = makeVar(0);
